// Single source of truth for external Discord destinations.
// Install URL adds the deck-check bot to a server; invite URL joins
// the Commandersalt community server (where Manuel lives).
export const DISCORD_BOT_INSTALL_URL =
    'https://discord.com/oauth2/authorize?client_id=1130881153998540800&permissions=2147483648&scope=bot';

export const DISCORD_INVITE_URL = 'https://discord.gg/Yb2CAxcJcf';

// Support + social destinations linked from the header and the info dialog.
export const PATREON_URL =
    'https://patreon.com/user?u=4796225&utm_medium=clipboard_copy&utm_source=copyLink&utm_campaign=creatorshare_creator&utm_content=join_link';

// Creator page opened from Settings' Patreon join / manage buttons.
export const PATREON_CREATOR_URL = 'https://www.patreon.com/c/user?u=4796225';

export const BLUESKY_URL = 'https://bsky.app/profile/commandersalt.bsky.social';
